var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company_container"},[_vm._v(" 企业动态待录入...... ")])}
var staticRenderFns = []

export { render, staticRenderFns }